var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 45",
    d: "M14.7956 15.3353C14.4537 14.3785 13.7004 13.533 12.6526 12.9299C11.6047 12.3269 10.3208 12 9 12C7.6792 12 6.3953 12.3269 5.34743 12.9299C4.29957 13.533 3.5463 14.3785 3.20445 15.3353",
    stroke: "#05073C",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 46",
    cx: 9,
    cy: 6,
    r: 3,
    stroke: "#05073C",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLight);
export default __webpack_public_path__ + "static/media/user_light.83503a0f66e808f3facdbe6460da6b8c.svg";
export { ForwardRef as ReactComponent };